import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'localizedDate'
})
export class LuxonDateFormatPipe implements PipeTransform {
    transform(value: string, format?: string): string {
        if (!value) return '';

        // Normalize format: map 'YYYY' to 'yyyy', 'DD' to 'dd'
        const normalizedFormat = (format ?? 'yyyy-MM-dd hh:mma').replace(/YYYY/g, 'yyyy').replace(/DD/g, 'dd');

        const dt = DateTime.fromISO(value, { zone: 'utc' }).toLocal();

        return dt.toFormat(normalizedFormat).toLowerCase();
    }
}
